import { useContext } from "react";
import { RepoContext } from "../top-level-contexts";

export function useRepos() {
  const context = useContext(RepoContext);
  return context;
}
